module.exports = __webpack_public_path__ + "d6fbaea9554be8a63a22e6f6ece8025f.png";